import { ErrorResponse } from '../api';

export const formatErrorResponse = (error: ErrorResponse): string => {
  if (error.errorDetails !== undefined) {
    const errorDetails = error.errorDetails;
    return Object.keys(errorDetails).reduce(
      (curr, next) =>
        next === 'error'
          ? errorDetails[next].join(', ')
          : curr + `\n${next}: ${errorDetails[next].join(', ')}`,
      ''
    );
  }
  if (error.reason !== undefined) {
    return error.reason;
  }
  if (error.errorMessage !== undefined) {
    return error.errorMessage;
  }
  return JSON.stringify(error);
};
